import { ColProps } from 'antd'

const CustomCard: React.FC<ColProps> = ({ style }) => <div style={style} className="card" />

export { CustomCard }
